import FeaturesItem from '@components/features-item';
import Grid from '@components/grid';
import Button from '@components/ui/button';
import Text from '@components/ui/text';
import React, { ReactElement } from 'react';
import Container from '@components/ui/container';
import CMSLink from '@components/CMSLink';

export default function FeatureLinkGrid(block: any): ReactElement {
  const { gridLink, title, subTitle, features, hasLink } = block;
  const { link } = gridLink;
  const isButton = hasLink;
  const isSubtitle = subTitle?.length > 0;

  return (
    <Container>
      <Grid>
        <div className="col-span-full">
          <Text variant="subHeading" className="text-black max-w-2xl">
            {title}
          </Text>
        </div>

        {isSubtitle ||
          (isButton && (
            <div className="hidden col-span-full md:block lg:col-span-4 border-t border-telesoft pt-8">
              {isSubtitle && (
                <Text variant="heading" className="font-medium text-heading">
                  {subTitle}
                </Text>
              )}

              {isButton && (
                <CMSLink {...link} className="w-full">
                  <Button variant="flat" className="mt-6">
                    {gridLink.link.label}
                  </Button>
                </CMSLink>
              )}
            </div>
          ))}
        {features?.map((feature: any, i: number) => {
          return (
            <FeaturesItem key={`feature-grid-map--${i}`} feature={feature} />
          );
        })}
      </Grid>
    </Container>
  );
}
